<template>
  <div class="reminders-meeting">
    <div v-if="displayMode === 'monthly'">
      <div>
        <el-date-picker
          style="float: right;"
          v-model="date.monthly"
          type="month"
          size="mini"
          :clearable="false"
          @change="handleDateChange">
        </el-date-picker>
        <h4 class="header-title m-t-0 m-b-20">Rendez-vous téléphoniques du mois</h4>
      </div>
      <month-timetable :events="events" :month="date.monthly" v-loading="loading">
        <template slot-scope="props">
          <span class="vue-timetable-event-color" :style="{ backgroundColor: props.event.color }"></span>
          <span class="vue-timetable-event-link">
            <el-tooltip class="item" effect="dark"
                        :content="props.event.title + ' ' + (props.event.meta.reminder.description ? ' : ' + props.event.meta.reminder.description : '')"
                        placement="top">
              <div>
                <span v-edit:reminder="props.event.meta.reminder" style="cursor: pointer">
                  <span class="vue-timetable-event-time">{{ props.event.date.from | moment('HH:mm')
                    }} - {{ props.event.date.to | moment('HH:mm') }}</span>
                </span>

                <div v-if="models.customers.find(customer => customer.id === props.event.meta.reminder.customer_id)">
                  <router-link :to="'/customers/' + props.event.meta.reminder.customer_id">
                    <customer
                      :item="models.customers.find(customer => customer.id === props.event.meta.reminder.customer_id)"
                      present="name"></customer>
                  </router-link>
                </div>
                <div v-else>
                  {{ props.event.description }}
                </div>
              </div>
            </el-tooltip>
          </span>
        </template>
      </month-timetable>
    </div>
    <div v-if="displayMode === 'weekly'">
      <div>
        <el-date-picker
          style="float: right;"
          v-model="date.weekly"
          type="week"
          size="mini"
          @change="handleDateChange">
        </el-date-picker>
        <h4 class="header-title m-t-0 m-b-20">Rendez-vous téléphoniques de la semaine</h4>
      </div>
      <week-timetable v-loading="loading" :events="events" :cell-height="75" :week="date.weekly"
                      :hour-range="{start: 8, end: 19}" :day-range="[1, 2, 3, 4, 5]">
        <template slot-scope="props">
          <el-tooltip class="item" effect="dark"
                      :content="props.event.title + ' ' + (props.event.meta.reminder.description ? ' : ' + props.event.meta.reminder.description : '')"
                      placement="top">
            <div style="font-size: 0.9em; text-align: center; width: 100%; height: 100%;">
              <div class="edit-button" v-edit:reminder="props.event.meta.reminder" style="cursor: pointer">
                <div><i class="fa fa-pencil"></i></div>
              </div>

              <div v-if="models.customers.find(customer => customer.id === props.event.meta.reminder.customer_id)">
                <router-link style="color: white;" :to="'/customers/' + props.event.meta.reminder.customer_id">
                  <div><strong>{{ props.event.date.from | moment('HH:mm') }} - {{ props.event.date.to | moment('HH:mm')
                    }}</strong></div>
                  <customer
                    :item="models.customers.find(customer => customer.id === props.event.meta.reminder.customer_id)"
                    present="name"></customer>
                </router-link>
              </div>
              <div v-else>
                <div><strong>{{ props.event.date.from | moment('HH:mm') }} - {{ props.event.date.to | moment('HH:mm')
                  }}</strong></div>
                {{ props.event.description }}
              </div>
            </div>
          </el-tooltip>
        </template>
      </week-timetable>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
  import MonthTimetable from 'vue-timetable/components/MonthTimetable'
  import WeekTimetable from 'vue-timetable/components/WeekTimetable.vue'
  import Customer from '@db2b/keystone/components/Entities/Customer.vue'
  import moment from 'moment'
  import Vue from 'vue'

  export default {
    components: {
      WeekTimetable,
      MonthTimetable,
      Customer
    },
    name: 'reminders-meetings-list',
    data () {
      return {
        date: {
          monthly: moment().format(),
          weekly: moment().startOf('week').isoWeekday(1).format()
        },
        range: this.getRange(moment(), this.displayMode),
        models: {
          reminders: [],
          customers: []
        },
        loading: false
      }
    },
    sync: {
      models: {
        reminders () {
          let self = this

          return {
            name: 'reminder',
            onCreate ({index, data, model}) {
              if (index === -1 && self.isReminderInCalendar(model)) { // Reate only non present and allowed
                data.push(model)
              }
            },
            onUpdate ({index, data, model}) {
              if (index === -1 && self.isReminderInCalendar(model)) { // If, not in calendar but should
                data.push(model)
              } else if (index !== -1 && !self.isReminderInCalendar(model)) { // If in calendar but should not
                data.splice(index, 1)
              } else { // The rest
                Vue.set(data, index, model)
              }
            }
          }
        },
        customers: 'customer'
      }
    },
    methods: {
      isReminderInCalendar (reminder) {
        if (!(reminder.user_id === this.$store.getters['users/current'].id)) return false
        if (!(reminder.category_id !== 8)) return false
        if (!(reminder.meeting)) return false
        if (!(moment(reminder.date.date).isBetween(this.range.from, this.range.to))) return false
        return true
      },
      handleDateChange (value) {
        let range = this.getRange(this.date[this.displayMode], this.displayMode)
        this.range.from = range.from
        this.range.to = range.to
      },
      getRange (now, displayMode) {
        let method = displayMode === 'weekly' ? 'week' : 'month'
        return {from: moment(now).startOf(method), to: moment(now).endOf(method)}
      }
    },
    computed: {
      events () {
        let self = this

        return this.models.reminders.map(item => {
          return self.$model['reminder'].toEvent(item)
        })
      },
      displayMode () {
        return this.$store.getters['user_preferences/current'].payload.reminders.meeting_display_mode
      }
    },
    created () {
      let self = this

      this.loading = true
      this.$nexus.get('callcenter', 'reminders', {
        params: {
          where: {
            user_id: this.$store.getters['users/current'].id,
            category_id: {'!=': 8},
            meeting: 1,
            date: {
              '>=': moment(self.range.from).format('YYYY-MM-DD'),
              '<=': moment(self.range.to).format('YYYY-MM-DD')
            }
          }
        }
      }).then(response => {
        self.models.reminders = response.data.data
        self.loading = false
      })
    },
    watch: {
      'models.reminders' () {
        let self = this

        this.$model.customer.getFromRelations(self.models.reminders).then(customers => {
          self.models.customers = customers
        })
      }
    }
  }
</script>

<style>
  .reminders-meeting .vue-timetable.vue-timetable-week-mode .vue-timetable-content .vue-timetable-columns .vue-timetable-column .vue-timetable-column-content .vue-timetable-event:hover {
    opacity: 1;
  }

  .reminders-meeting .vue-timetable-event .edit-button {
    float: right;
    display: table;
    height: 100%;
    width: 0%;
    background-color: rgba(255, 255, 255, 0.2)
  }

  .reminders-meeting .vue-timetable-event:hover .edit-button {
    transition: 0.1s;
    width: 20%;
    position: absolute;
    right: 0;
    top: 0;
  }

  .reminders-meeting .vue-timetable-event .edit-button div {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
  }

  .reminders-meeting .vue-timetable-event .edit-button div i {
    font-size: 0em;
  }

  .reminders-meeting .vue-timetable-event:hover .edit-button div i {
    transition: 0.1s;
    font-size: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// RemindersMeetingsList.vue?16a80b32